module.exports = __webpack_public_path__ + "static/4-c0d655784cb90ba08aaaf11ffe6931e0.jpg";